function $parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
var $parcel$global = globalThis;
var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("jEc6C", function(module, exports) {
    var $dJZWD;
    const $3ef2973850dc3c26$var$addDNSPrefetchLink = (url)=>{
        const linkElem = document.createElement('link');
        linkElem.rel = 'dns-prefetch';
        linkElem.href = url;
        document.getElementsByTagName('head')[0].appendChild(linkElem);
    };
    (0, (0, parcelRequire("dJZWD")).setupConnectJs)();
    fetch('/rest/atlassian-connect/latest/addons-baseurl').then((response)=>response.ok ? response.json() : {}).then((json)=>json.addonBaseUrls && json.addonBaseUrls.forEach($3ef2973850dc3c26$var$addDNSPrefetchLink)).catch(()=>{});
});
parcelRegister("dJZWD", function(module, exports) {
    $parcel$export(module.exports, "setupConnectJs", ()=>$762ba9fa524ea8e6$export$891414b605e5f038);
    var $6BZYo;
    var $cQZXC;
    var $4R6GH;
    var $dH9DT;
    const $762ba9fa524ea8e6$var$installConnectJs = async ()=>{
        if ((0, (0, parcelRequire("4R6GH")).fg)('bifrost-gateway-tmp-no-wrm-via-ssr')) await (0, (0, parcelRequire("cQZXC")).waitForHeritage)();
        await (0, (0, parcelRequire("dH9DT")).waitForJQuery)();
        const loader = await (parcelRequire("gRUhY"));
        await loader.performSideEffects();
        return window.connectHost;
    };
    let $762ba9fa524ea8e6$var$installConnectJsPromise = null;
    const $762ba9fa524ea8e6$export$891414b605e5f038 = async ()=>{
        if (window.__SPA__) {
            if ($762ba9fa524ea8e6$var$installConnectJsPromise === null) $762ba9fa524ea8e6$var$installConnectJsPromise = $762ba9fa524ea8e6$var$installConnectJs();
            return $762ba9fa524ea8e6$var$installConnectJsPromise;
        }
        await (0, (0, parcelRequire("6BZYo")).loadBridge)({
            name: 'ac/create',
            wrmKeys: [
                'wrc!com.atlassian.plugins.atlassian-connect-plugin:jira-atlassian-connect-resources-v5',
                'wrc!com.atlassian.jira.jira-atlaskit-plugin:sidebar'
            ]
        });
        return window.connectHost;
    };
});
parcelRegister("6BZYo", function(module, exports) {
    $parcel$export(module.exports, "loadBridge", ()=>$ce95ee3fd66207c7$export$df8409da353bde5a);
    var $fqWWz;
    var $3GASE;
    var $ig88W;
    var $7T84i;
    var $7T84i;
    var $9B86Q;
    var $cQZXC;
    var $8JNtu;
    var $5Ik5Y;
    const $ce95ee3fd66207c7$export$df8409da353bde5a = ({ name: name, wrmKeys: wrmKeys, tentatives: tentatives = (0, (0, parcelRequire("fqWWz")).MAX_RETRIES), timeout: timeout = (0, (0, parcelRequire("fqWWz")).DEFAULT_TIMEOUT), shouldLogError: shouldLogError = (0, (0, parcelRequire("fqWWz")).SHOULD_LOG_ERROR) })=>{
        if (wrmKeys != null) return (0, (0, parcelRequire("7T84i")).loadBridgeStrict)({
            name: name,
            wrmKeys: [].concat(wrmKeys),
            shouldLogError: shouldLogError
        });
        if (tentatives <= 0) return Promise.reject(new Error('Unable to load bridge, zero tentatives never works'));
        if (tentatives <= 1) return (0, (0, parcelRequire("3GASE")).loadBridgeBail)({
            name: name,
            shouldLogError: shouldLogError
        });
        return (0, (0, parcelRequire("ig88W")).loadBridgeRace)({
            name: name,
            shouldLogError: shouldLogError,
            timeout: (tentatives - 1) * timeout
        });
    };
});
parcelRegister("fqWWz", function(module, exports) {
    $parcel$export(module.exports, "safeErrorWithoutCustomerData", ()=>$71bf66166926d1dc$export$f19a2d31722e3428);
    $parcel$export(module.exports, "MAX_RETRIES", ()=>$71bf66166926d1dc$export$1f86472c1374185a);
    $parcel$export(module.exports, "DEFAULT_TIMEOUT", ()=>$71bf66166926d1dc$export$7bd623b29ec8e1eb);
    $parcel$export(module.exports, "SHOULD_LOG_ERROR", ()=>$71bf66166926d1dc$export$37f20f0ff732fcd7);
    var $dJl1T;
    const { safeErrorWithoutCustomerData: $71bf66166926d1dc$export$f19a2d31722e3428, safeInfoWithoutCustomerData: $71bf66166926d1dc$export$ea810ce67e3c8eac } = (0, (0, parcelRequire("dJl1T")).default);
    const $71bf66166926d1dc$export$1f86472c1374185a = 40;
    const $71bf66166926d1dc$export$7bd623b29ec8e1eb = 500;
    const $71bf66166926d1dc$export$37f20f0ff732fcd7 = true;
});
parcelRegister("3GASE", function(module, exports) {
    $parcel$export(module.exports, "loadBridgeBail", ()=>$e512b6cc4a8702e5$export$a036f92c2465504e);
    var $wRU6t;
    var $fqWWz;
    const $e512b6cc4a8702e5$export$a036f92c2465504e = async ({ name: name, shouldLogError: shouldLogError = (0, (0, parcelRequire("fqWWz")).SHOULD_LOG_ERROR) })=>{
        try {
            return window.require(name);
        } catch (error) {
            if (shouldLogError) (0, (0, parcelRequire("fqWWz")).safeErrorWithoutCustomerData)('common.bridge', `Unable to load bridge "${name}". ${(0, (0, parcelRequire("wRU6t")).safeStringify)(error) ?? ''}`, {
                isSpa: __SPA__,
                name: name,
                error: (0, (0, parcelRequire("wRU6t")).safeStringify)(error)
            });
            throw new Error(`Unable to load bridge "${name}"`, {
                cause: error
            });
        }
    };
});
parcelRegister("wRU6t", function(module, exports) {
    $parcel$export(module.exports, "safeStringify", ()=>$7e2bd894031d4476$export$56831a8b9cb27763);
    const $7e2bd894031d4476$export$56831a8b9cb27763 = (object)=>{
        if (!object) return '';
        if (object instanceof Error) return object.stack || object.message;
        return JSON.stringify(object, Object.getOwnPropertyNames(object));
    };
});
parcelRegister("ig88W", function(module, exports) {
    $parcel$export(module.exports, "loadBridgeRace", ()=>$64f1dbae1ea314ee$export$20c32b4579d78b92);
    var $3GASE;
    var $9B86Q;
    var $fqWWz;
    const $64f1dbae1ea314ee$export$20c32b4579d78b92 = ({ name: name, timeout: timeout = (0, (0, parcelRequire("fqWWz")).DEFAULT_TIMEOUT), shouldLogError: shouldLogError = (0, (0, parcelRequire("fqWWz")).SHOULD_LOG_ERROR) })=>Promise.race([
            (0, (0, parcelRequire("9B86Q")).loadBridgeWeak)({
                name: name
            }),
            new Promise((resolve)=>setTimeout(resolve, timeout)).then(()=>(0, (0, parcelRequire("3GASE")).loadBridgeBail)({
                    name: name,
                    shouldLogError: shouldLogError
                }))
        ]);
});
parcelRegister("9B86Q", function(module, exports) {
    $parcel$export(module.exports, "loadBridgeWeak", ()=>$61b2a5aa3a2a1160$export$3cefda82396756a1);
    var $ifVVd;
    let $61b2a5aa3a2a1160$var$pollingSingleton = null;
    const $61b2a5aa3a2a1160$export$3cefda82396756a1 = ({ name: name })=>{
        const getter = $61b2a5aa3a2a1160$var$pollingSingleton ?? (0, (0, parcelRequire("ifVVd")).createPollingCollection)((v)=>window.require(v), 100);
        $61b2a5aa3a2a1160$var$pollingSingleton = getter;
        return getter(name);
    };
});
parcelRegister("ifVVd", function(module, exports) {
    $parcel$export(module.exports, "createPollingCollection", ()=>$60e6b0d4bc46beac$export$f163446a982a8077);
    var $gKZoD;
    var $aePFs;
    const $60e6b0d4bc46beac$export$f163446a982a8077 = (fn, timeout)=>{
        (0, (0, parcelRequire("gKZoD")).di)(setTimeout);
        let isPolling = false;
        const deferredMap = new Map();
        const promiseMap = new Map();
        const evaluateForKey = (key)=>{
            let result;
            try {
                result = fn(key);
            } catch (error) {
                return;
            }
            const deferred = deferredMap.get(key);
            if (deferred instanceof (0, (0, parcelRequire("aePFs")).default)) {
                deferred.resolve(result);
                deferredMap.delete(key);
            }
        };
        const maybePoll = ()=>{
            if (!isPolling && deferredMap.size > 0) {
                isPolling = true;
                setTimeout(()=>{
                    isPolling = false;
                    [
                        ...deferredMap.keys()
                    ].forEach(evaluateForKey);
                    maybePoll();
                }, timeout);
            }
        };
        const getter = (key)=>{
            if (!promiseMap.has(key)) {
                const deferred = new (0, (0, parcelRequire("aePFs")).default)();
                const promise = deferred.then((v)=>v);
                deferredMap.set(key, deferred);
                promiseMap.set(key, promise);
                evaluateForKey(key);
                maybePoll();
            }
            return promiseMap.get(key);
        };
        return getter;
    };
});
parcelRegister("aePFs", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$02f3c6551bf5b1ff$export$2e2bcd8739ae039);
    class $02f3c6551bf5b1ff$export$2e2bcd8739ae039 extends Promise {
        static resolve(v) {
            const instance = new $02f3c6551bf5b1ff$export$2e2bcd8739ae039();
            instance.resolve(v);
            return instance;
        }
        static reject(e) {
            const instance = new $02f3c6551bf5b1ff$export$2e2bcd8739ae039();
            instance.reject(e);
            return instance;
        }
        constructor(){
            const [fn] = Array.prototype.slice.call(arguments);
            const callbacks = [];
            super(fn ?? callbacks.push.bind(callbacks));
            this.#resolve = callbacks[0];
            this.#reject = callbacks[1];
        }
        #resolve;
        #reject;
        resolve(v) {
            this.#resolve?.(v);
        }
        reject(e) {
            this.#reject?.(e);
        }
    }
});
parcelRegister("7T84i", function(module, exports) {
    $parcel$export(module.exports, "loadBridgeStrict", ()=>$89a95eb8b151782d$export$eba600d28decc4ac);
    var $c56lL;
    var $ig88W;
    var $fVOHM;
    var $fqWWz;
    const $89a95eb8b151782d$export$eba600d28decc4ac = async ({ name: name, wrmKeys: wrmKeys, shouldLogError: shouldLogError = (0, (0, parcelRequire("fqWWz")).SHOULD_LOG_ERROR) })=>{
        (0, (0, parcelRequire("c56lL")).saveStats)(name, wrmKeys);
        try {
            return window.require(name);
        } catch (error) {
            await (0, (0, parcelRequire("fVOHM")).loadWrmResources)({
                wrmKeys: wrmKeys,
                shouldLogError: shouldLogError
            });
            return (0, (0, parcelRequire("ig88W")).loadBridgeRace)({
                name: name,
                shouldLogError: shouldLogError
            });
        }
    };
});
parcelRegister("c56lL", function(module, exports) {
    $parcel$export(module.exports, "saveStats", ()=>$6c875a5034ae8433$export$9ea3ff7978093559);
    const $6c875a5034ae8433$var$incrementResourceStats = (resource, stats)=>{
        if (stats[resource] == null) stats[resource] = 1;
        else stats[resource] += 1;
    };
    const $6c875a5034ae8433$var$getEmptyLoadBridgeStats = ()=>({
            requests: 0,
            amdModules: {},
            wrmKeys: {}
        });
    const $6c875a5034ae8433$var$initStats = ()=>{
        if (window.__WRM_INTERNAL_STATS__ == null) window.__WRM_INTERNAL_STATS__ = {
            loadBridge: $6c875a5034ae8433$var$getEmptyLoadBridgeStats()
        };
        else if (window.__WRM_INTERNAL_STATS__.loadBridge == null) window.__WRM_INTERNAL_STATS__.loadBridge = $6c875a5034ae8433$var$getEmptyLoadBridgeStats();
        return window.__WRM_INTERNAL_STATS__.loadBridge;
    };
    const $6c875a5034ae8433$var$isPageInteractive = ()=>window.__WRM_INTERNAL_STATS__?.isPageInteractive;
    const $6c875a5034ae8433$export$9ea3ff7978093559 = (amdModuleName, wrmKeys)=>{
        try {
            const stats = $6c875a5034ae8433$var$initStats();
            if ($6c875a5034ae8433$var$isPageInteractive()) return;
            stats.requests += 1;
            $6c875a5034ae8433$var$incrementResourceStats(amdModuleName, stats.amdModules);
            if (Array.isArray(wrmKeys)) wrmKeys.forEach((wrmKey)=>$6c875a5034ae8433$var$incrementResourceStats(wrmKey, stats.wrmKeys));
            else if (wrmKeys != null) $6c875a5034ae8433$var$incrementResourceStats(wrmKeys, stats.wrmKeys);
        } catch (e) {}
    };
});
parcelRegister("fVOHM", function(module, exports) {
    $parcel$export(module.exports, "loadWrmResources", ()=>$0c0552c7bb135144$export$6cda16b6eff75f59);
    var $wRU6t;
    var $294PS;
    var $9B86Q;
    var $fqWWz;
    const $0c0552c7bb135144$export$6cda16b6eff75f59 = async ({ wrmKeys: wrmKeys, shouldLogError: shouldLogError, ...options })=>{
        const isPrefetch = 'batchUrl' in options;
        let newWrmKeys = wrmKeys;
        try {
            const name = isPrefetch ? 'wrm/require-v2' : 'wrm/require';
            const wrmRequireModule = await (0, (0, parcelRequire("9B86Q")).loadBridgeWeak)({
                name: name
            });
            const wrmRequire = isPrefetch ? wrmRequireModule.requireWithPrefetch : wrmRequireModule;
            newWrmKeys = (0, (0, parcelRequire("294PS")).prependSuperBatchDepsOnce)(wrmKeys);
            if (isPrefetch) return await new Promise((resolve, reject)=>wrmRequire(newWrmKeys, options.batchUrl)?.then?.(resolve, reject) ?? reject(new Error('wrmRequire returned non-Deferred result')));
            return await new Promise((resolve, reject)=>wrmRequire(newWrmKeys)?.then?.(resolve, reject) ?? reject(new Error('wrmRequire returned non-Deferred result')));
        } catch (error) {
            if (shouldLogError) (0, (0, parcelRequire("fqWWz")).safeErrorWithoutCustomerData)('common.bridge.wrm', 'Unable to load wrm resource', {
                isSpa: __SPA__,
                wrmKeys: JSON.stringify(newWrmKeys),
                error: (0, (0, parcelRequire("wRU6t")).safeStringify)(error)
            });
            throw new Error('Unable to load wrm resource', {
                cause: error
            });
        }
    };
});
parcelRegister("294PS", function(module, exports) {
    $parcel$export(module.exports, "prependSuperBatchDepsOnce", ()=>$a437264dd6b89021$export$93d9db5fbabad1b0);
    var $1r4rO;
    let $a437264dd6b89021$var$isSuperBatchDependenciesLoaded = false;
    const $a437264dd6b89021$var$isOnRapidBoardsPage = ()=>{
        const boardsRegex = /\/jira\/software\/c\/projects\/[A-Za-z0-9]{1,10}\/boards\/[0-9]*[/]?$/;
        const backlogsRegex = /\/jira\/software\/c\/projects\/[A-Za-z0-9]{1,10}\/boards\/[0-9]*\/backlog[/]?$/;
        const { pathname: pathname } = window.location;
        return boardsRegex.test(pathname) || backlogsRegex.test(pathname) || window.location.href.includes('secure/RapidBoard.jspa');
    };
    const $a437264dd6b89021$export$93d9db5fbabad1b0 = (wrmKeys)=>{
        if ($a437264dd6b89021$var$isSuperBatchDependenciesLoaded || $a437264dd6b89021$var$isOnRapidBoardsPage()) return wrmKeys;
        $a437264dd6b89021$var$isSuperBatchDependenciesLoaded = true;
        return (0, (0, parcelRequire("1r4rO")).jiraSuperBatchDependencies).concat(wrmKeys);
    };
});
parcelRegister("1r4rO", function(module, exports) {
    $parcel$export(module.exports, "jiraSuperBatchDependencies", ()=>$e87d6a02e2466ae8$export$f14a6b583ce9e077);
    const $e87d6a02e2466ae8$export$f14a6b583ce9e077 = [
        'wrc!jira.webresources:skate',
        'wrc!jira.webresources:util-lite',
        'wrc!jira.webresources:util',
        'wrc!jira.webresources:feature-flags',
        'wrc!jira.webresources:dialogs',
        'wrc!jira.webresources:jira-global',
        'wrc!com.atlassian.auiplugin:aui-spinner'
    ];
});
parcelRegister("cQZXC", function(module, exports) {
    $parcel$export(module.exports, "waitForHeritage", ()=>$90def0f7a7aa11d6$export$c61060338d026f78);
    var $4R6GH;
    var $7aBP4;
    var $aePFs;
    const $90def0f7a7aa11d6$export$c61060338d026f78 = ()=>{
        if (false) return null;
        if (!__SPA__) return Promise.resolve();
        if (!window.__WAIT_FOR_HERITAGE__) {
            window.__WAIT_FOR_HERITAGE__ = new (0, (0, parcelRequire("aePFs")).default)();
            if ((0, (0, parcelRequire("4R6GH")).fg)('bifrost-gateway-tmp-no-wrm-via-ssr')) (0, (0, parcelRequire("7aBP4")).bootstrapWrmClient)().then(()=>{
                window.__WAIT_FOR_HERITAGE__.resolve();
            });
        }
        return window.__WAIT_FOR_HERITAGE__;
    };
});
parcelRegister("7aBP4", function(module, exports) {
    $parcel$export(module.exports, "bootstrapWrmClient", ()=>$f93199c7ae9c59d8$export$d001f71dd306cb0c);
    var $7f4tk;
    const $f93199c7ae9c59d8$var$SPA_WRM_CONTEXT_ENDPOINT = '/rest/frontend/1/spawrmcontext';
    const $f93199c7ae9c59d8$var$fetchSpaWrmContext = async ()=>{
        return (0, (0, parcelRequire("7f4tk")).default)($f93199c7ae9c59d8$var$SPA_WRM_CONTEXT_ENDPOINT);
    };
    const $f93199c7ae9c59d8$var$createResourceElement = ({ url: url, resourceType: resourceType, key: key, batchType: batchType })=>{
        let element;
        if (resourceType === 'JAVASCRIPT') {
            element = globalThis.document?.createElement('script');
            element.setAttribute('crossorigin', '');
            element.setAttribute('src', url);
            element.setAttribute('data-client-bootstrapped', '');
            element.setAttribute('data-wrm-key', key);
            element.setAttribute('data-wrm-batch-type', batchType.toLowerCase());
        } else {
            element = globalThis.document?.createElement('link');
            element.setAttribute('crossorigin', '');
            element.setAttribute('href', url);
            element.setAttribute('rel', 'stylesheet');
            element.setAttribute('media', 'all');
            element.setAttribute('data-client-bootstrapped', '');
            element.setAttribute('data-wrm-key', key);
            element.setAttribute('data-wrm-batch-type', batchType.toLowerCase());
        }
        return element;
    };
    let $f93199c7ae9c59d8$var$hasWrmInitialised;
    const $f93199c7ae9c59d8$var$runBootstrap = ()=>{
        const spaWrmContext = $f93199c7ae9c59d8$var$fetchSpaWrmContext();
        return new Promise((resolve)=>{
            spaWrmContext.then(({ data: data, errors: errors, resources: resources })=>{
                const WRM = globalThis.WRM = globalThis.WRM || {};
                WRM._unparsedData = data;
                WRM._unparsedErrors = errors;
                if (WRM._dataArrived) WRM._dataArrived();
                resources.map($f93199c7ae9c59d8$var$createResourceElement).forEach((element)=>globalThis.document?.head.appendChild(element));
                resolve();
            });
        });
    };
    const $f93199c7ae9c59d8$export$d001f71dd306cb0c = ()=>{
        if (false) return Promise.resolve();
        if ($f93199c7ae9c59d8$var$hasWrmInitialised) return $f93199c7ae9c59d8$var$hasWrmInitialised;
        if (typeof globalThis.WRM !== 'undefined') $f93199c7ae9c59d8$var$hasWrmInitialised = Promise.resolve();
        else $f93199c7ae9c59d8$var$hasWrmInitialised = $f93199c7ae9c59d8$var$runBootstrap();
        return $f93199c7ae9c59d8$var$hasWrmInitialised;
    };
});
parcelRegister("8JNtu", function(module, exports) {
    $parcel$export(module.exports, "wrmRequire", ()=>$17e2d7d864398bad$export$cc9d8f51375ef66a);
    var $fVOHM;
    var $fqWWz;
    const $17e2d7d864398bad$export$cc9d8f51375ef66a = async (wrmKeys, shouldLogError = (0, (0, parcelRequire("fqWWz")).SHOULD_LOG_ERROR))=>(0, (0, parcelRequire("fVOHM")).loadWrmResources)({
            wrmKeys: wrmKeys,
            shouldLogError: shouldLogError
        });
});
parcelRegister("5Ik5Y", function(module, exports) {
    $parcel$export(module.exports, "wrmRequireWithPrefetch", ()=>$a1df1daee76d40f7$export$e53a5db19a39ed2f);
    var $fVOHM;
    var $fqWWz;
    const $a1df1daee76d40f7$export$e53a5db19a39ed2f = async (wrmKeys, batchUrl, shouldLogError = (0, (0, parcelRequire("fqWWz")).SHOULD_LOG_ERROR))=>(0, (0, parcelRequire("fVOHM")).loadWrmResources)({
            wrmKeys: wrmKeys,
            shouldLogError: shouldLogError,
            batchUrl: batchUrl
        });
});
parcelRegister("dH9DT", function(module, exports) {
    $parcel$export(module.exports, "getMeta", ()=>$a78c52ec7ed5d025$export$c47913ca32a5c6f7);
    $parcel$export(module.exports, "getJQuery", ()=>$a78c52ec7ed5d025$export$7232a6dc780f9887);
    $parcel$export(module.exports, "getGlobalAP", ()=>$a78c52ec7ed5d025$export$fbc82125a6bd8012);
    $parcel$export(module.exports, "isObject", ()=>$a78c52ec7ed5d025$export$a6cdc56e425d0d0a);
    $parcel$export(module.exports, "escapeSelector", ()=>$a78c52ec7ed5d025$export$c8c0ea01c118c2eb);
    $parcel$export(module.exports, "waitForJQuery", ()=>$a78c52ec7ed5d025$export$97214de9c546981c);
    $parcel$export(module.exports, "ErrorDebugAddonKeys", ()=>$a78c52ec7ed5d025$export$d690da9bc8146677);
    var $jcw0u;
    const $a78c52ec7ed5d025$export$c47913ca32a5c6f7 = (key)=>{
        const metaTag = document.querySelector(`meta[name='ajs-${key}']`);
        return metaTag === null ? undefined : metaTag.getAttribute('content') || undefined;
    };
    const $a78c52ec7ed5d025$export$7232a6dc780f9887 = ()=>AJS.$;
    const $a78c52ec7ed5d025$export$fbc82125a6bd8012 = ()=>window._AP;
    const $a78c52ec7ed5d025$export$a6cdc56e425d0d0a = (obj)=>typeof obj === 'function' || typeof obj === 'object' && !!obj;
    const $a78c52ec7ed5d025$export$c8c0ea01c118c2eb = (s)=>{
        if (!s) throw new Error('No selector to escape');
        return s.replace(/[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~]/g, '\\$&');
    };
    const $a78c52ec7ed5d025$var$FIVE_MINUTES = 300000;
    const $a78c52ec7ed5d025$export$97214de9c546981c = ()=>new Promise((resolve, reject)=>{
            const interval = setInterval(()=>{
                if (window.AJS?.$) {
                    clearInterval(interval);
                    resolve();
                }
            }, 10);
            setTimeout(()=>{
                clearInterval(interval);
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'connect-jquery-timeout',
                        packageName: 'jiraConnect'
                    },
                    error: new Error('Timeout when waiting for jQuery to be available on the page'),
                    skipSentry: true
                });
                reject();
            }, $a78c52ec7ed5d025$var$FIVE_MINUTES);
        });
    const $a78c52ec7ed5d025$export$7315c38dc71bd41f = 'com.atlassian.servicedesk.embedded-dev';
    const $a78c52ec7ed5d025$export$cb954c21735b28e4 = 'com.atlassian.servicedesk.embedded';
    const $a78c52ec7ed5d025$export$d690da9bc8146677 = [
        $a78c52ec7ed5d025$export$cb954c21735b28e4,
        $a78c52ec7ed5d025$export$7315c38dc71bd41f
    ];
});
parcelRegister("gRUhY", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("aVR4N").then(()=>parcelRequire('8vJyT'));
});
